'use client';

import { usePathname } from 'next/navigation';

import { MyAsideNavigationLayout } from '../_components/MyAsideNavigationLayout';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  // /donation/my/etc/event/{eventId} 패턴 체크
  if (pathname?.startsWith('/donation/my/etc/event/')) {
    return children;
  }

  return <MyAsideNavigationLayout>{children}</MyAsideNavigationLayout>;
};

export default Layout;
